import IconChevronDown from '@apollo/icons/small/IconChevronDown.svg';
import {
  Button,
  ButtonGroup,
  ButtonProps,
  IconButton,
  Menu,
  MenuButton,
  MenuContent,
  MenuItem,
  MenuList,
} from '@apollo/orbit';
import React from 'react';
import { LinkProps } from 'react-router-dom';

export const SplitButton = React.forwardRef<
  HTMLDivElement,
  {
    menuItems?: React.ReactElement<typeof MenuItem>[];
    ariaLabel: string;
  } & ButtonProps &
    LinkProps
>(
  (
    { children, isDisabled, menuItems, ariaLabel, className, ...buttonProps },
    ref,
  ) => {
    return (
      <ButtonGroup
        isDisabled={isDisabled}
        isAttached={!!menuItems}
        className={className}
        ref={ref}
      >
        <Button {...buttonProps}>{children}</Button>
        {menuItems && (
          <Menu placement="bottom-end" autoSelect={false}>
            <MenuButton
              as={IconButton}
              aria-label={ariaLabel}
              type="button"
              variant={buttonProps.variant}
              size={buttonProps.size}
            >
              <IconChevronDown />
            </MenuButton>
            <MenuContent>
              <MenuList>{menuItems}</MenuList>
            </MenuContent>
          </Menu>
        )}
      </ButtonGroup>
    );
  },
);
